export default __webpack_public_path__ + "static/media/logo.ee37b5e8.svg";